/* eslint-disable react/prop-types */
import React from 'react';
import classnames from 'classnames';

import Date from '../../../common/date';
import Time from '../../../common/Time';
import Money from '../../../common/money';
import { fullName } from '../../../common/helpers/users';
import { t } from '../../../../modules/infra/i18n';

const barbersToString = barbers => (
  barbers
    .map(barber => fullName(barber, true))
    .join(', ')
);

const customersToString = customers => (
  customers
    .map(customer => fullName(customer))
    .join(', ')
);

export const ReceiptBarberName = (props) => {
  const hasAppointment = props.value.some(b => b.appointmentTime);
  if (!hasAppointment) {
    return (
      <div className="u-pre-wrap">{barbersToString(props.value) || t('register:summary.table.unassigned_sale')}</div>
    );
  }

  return (
    <div>
      {
        props.value.map(barber => (
          <div key={barber.id}>
            {fullName(barber, true)}
            <span display-if={barber.appointmentTime}>&nbsp;-&nbsp;
              <Date>{barber.appointmentTime}</Date>
                @
                <Time>{barber.appointmentTime}</Time>
            </span>
          </div>
        ))
      }
    </div>
  );
};

export const ReceiptCustomer = props => (
  <div className="u-pre-wrap">{customersToString(props.value) || t('register:summary.table.unassigned_sale')}</div>
);

export const ReceiptTotalCharge = props => (
  <div className={classnames({ 'u-co-red': props.value <= 0 })}>
    <Money>{props.value}</Money>
  </div>
);
